// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-container {\n  display: inline-flex;\n  align-items: center;\n}\n.status-container .status-title {\n  display: inline-block;\n  padding: 0 16px;\n  line-height: 32px;\n  height: 32px;\n  font-size: 14px;\n  color: #000000;\n}\n.status-container .status-options {\n  display: inline-block;\n  box-sizing: border-box;\n  border: 1px solid #d9d9d9;\n  margin: 0;\n}\n.status-container .status-options .status-option {\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
